module.exports = __webpack_public_path__ + "static/img/img-4.a67efd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/img/img-4.png
// module id = tQf7
// module chunks = 1